<div class="registration-container">
  @if (isLoading) {
    <app-loading-cybera [showLogo]="true" />
  } @else {
    <form class="p-2 pt-4 h-full content-center" [formGroup]="form">
      <landingpage-affiliate-logo />
      <h2 i18n class="my-4 font-normal">Registration</h2>
      @if (error) {
        <div class="error">
          <span class="ml-2" i18n>Some fields are incorrect</span>
        </div>
      }
      <div class="registration-inputs">
        <div>
          <label for="firstName" i18n>First Name</label>
          <input
            id="firstName"
            type="text"
            pInputText
            fluid
            i18n-placeholder
            placeholder="Enter your first name"
            [formControl]="form.controls.firstName"
            [ngClass]="{
              'ng-invalid ng-dirty':
                (form.controls.firstName.touched || form.controls.firstName.dirty) &&
                form.controls.firstName.invalid,
            }" />
        </div>

        <div>
          <label for="lastName" i18n>Last Name</label>
          <input
            id="lastName"
            type="text"
            pInputText
            fluid
            i18n-placeholder
            placeholder="Enter your last name"
            [formControl]="form.controls.lastName"
            [ngClass]="{
              'ng-invalid ng-dirty':
                (form.controls.lastName.touched || form.controls.lastName.dirty) &&
                form.controls.lastName.invalid,
            }" />
        </div>
        <div class="flex space-between flex-col max-width">
          <label for="email" i18n>Email</label>
          <input
            id="email"
            type="text"
            pInputText
            fluid
            i18n-placeholder
            placeholder="Enter your email"
            [formControl]="form.controls.email"
            [ngClass]="{
              'ng-invalid ng-dirty':
                (form.controls.email.touched || form.controls.email.dirty) &&
                form.controls.email.invalid,
            }" />
        </div>
        <div class="flex flex-col">
          <!--suppress XmlInvalidId -->
          <label for="pass" i18n>Password</label>
          <p-password
            inputId="pass"
            i18n-placeholder
            fluid
            placeholder="Choose your password"
            [formControl]="form.controls.password"
            [toggleMask]="true"
            [ngClass]="{
              'ng-invalid ng-dirty':
                (form.controls.password.touched || form.controls.password.dirty) &&
                form.controls.password.invalid,
            }">
            <ng-template #footer>
              <p-divider />
              @if (
                form.controls.password.errors?.lengthInvalid ||
                form.controls.password.errors?.missingUpperCase ||
                form.controls.password.errors?.missingLowerCase ||
                form.controls.password.errors?.missingNumber ||
                form.controls.password.errors?.missingSpecialChar
              ) {
                <span>Password requirements: </span>
              }
              <ul class="list-inside list-disc m-0 error-list">
                @if (form.controls.password.errors?.lengthInvalid) {
                  <li>
                    <span i18n>{{ minPasswordLength }} character minimum</span>
                  </li>
                }
                @if (form.controls.password.errors?.lengthInvalid) {
                  <li>
                    <span i18n>{{ maxPasswordLength }} character maximum</span>
                  </li>
                }
                @if (form.controls.password.errors?.missingUpperCase) {
                  <li>
                    <span i18n>One uppercase character</span>
                  </li>
                }
                @if (form.controls.password.errors?.missingLowerCase) {
                  <li>
                    <span i18n>One lowercase character</span>
                  </li>
                }
                @if (form.controls.password.errors?.missingNumber) {
                  <li>
                    <span i18n>One number</span>
                  </li>
                }
                @if (form.controls.password.errors?.missingSpecialChar) {
                  <li>
                    <span i18n>One special character</span>
                  </li>
                }
              </ul>
            </ng-template>
          </p-password>
        </div>

        <div class="flex flex-row">
          <p-checkbox
            [formControl]="form.controls.accept"
            [value]="false"
            [binary]="true"
            inputId="crime" />
          <label for="crime" class="mb-0 ml-2" i18n
            >I understand that false reporting is a crime</label
          >
        </div>
        <div class="col-span-12 md:col-span-5 xl:col-span-6 p-0 mt-2">
          <p-button
            class="register w-full mb-2 md:w-auto md:mb-1"
            label="Register and Continue"
            i18n-label
            (onClick)="register()" />
        </div>
      </div>
      <div class="mt-2 flex justify-center items-center gap-2">
        <span class="mb-0 mt-0" i18n>Already have an account?</span>
        <p-button
          label="Log in now"
          (onClick)="msal.loginRedirect()"
          i18n-label
          text="true"
          size="small" />
      </div>
    </form>
  }
</div>
